import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { IDirectReport } from '../../lookups';
import {
    DynamicDialogConfig,
    DynamicDialogRef,
    SelectItem
} from '../../shared/efaact-primeng.module';
import { IUser } from '../../user-info';

@Component({
    selector: 'ef-reconciliation-share-template-popup',
    templateUrl: './reconciliation-share-template-popup.component.html',
    styleUrls: ['./reconciliation-share-template-popup.component.scss'],
    standalone: false
})
export class ReconciliationShareTemplatePopupComponent implements OnInit {
    form: UntypedFormGroup;
    constructor(
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private log: LoggingService
    ) {
        this.form = new UntypedFormGroup({
            Users: new UntypedFormControl(null, Validators.required)
        });
    }

    ngOnInit(): void {}
}
